import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconDropBox: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path d="M23 1l-7 6 9 6 7-6z" fill={fill} />
      <path d="M16 7l-7-6-9 6 7 6z" fill={fill} />
      <path d="M25 13l7 6-9 5-7-6z" fill={fill} />
      <path d="M16 18l-9-5-7 6 9 5z" fill={fill} />
      <path
        d="M22.755 26.424l-6.755-5.79-6.755 5.79-4.245-2.358v2.934l11 5 11-5v-2.934z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconDropBox;
